import { component } from 'picoapp';
import { fetchCart } from '../../js/lib/cart'; // eslint-disable-line
import UpsellItem from '../../js/lib/upsell-item';
import Drawer from '../../js/utils/drawer';
import GiftProduct from '../../js/utils/gift'; // eslint-disable-line
import Modal from '../../js/utils/modal';
import app from '../app'; // eslint-disable-line

export default component(async (node, ctx) => {
  /**
   * Data + elements
   */
  const itemCountOutput = node.querySelector('.js-itemCount');
  const closeBtns = node.querySelectorAll('.js-closeBtn');
  const mainContents = node.querySelector('.js-mainContents');
  const itemList = node.querySelector('.js-itemList');
  const discountsInfo = node.querySelector('.js-discountsInfo');
  const discountsLine = node.querySelector('.js-discountsLine');
  const totalPrice = node.querySelector('.js-totalPrice');
  const form = node.querySelector('.js-form');
  const termsInput = node.querySelector('.js-termsInput');
  const termsModal = node.querySelector('.js-termsModal');
  const termsAcceptBtn = node.querySelector('.js-termsAcceptBtn');
  const termsDeclineBtn = node.querySelector('.js-termsDeclineBtn');
  const empty = node.querySelector('.js-empty');
  const upsellDrawer = node.querySelector('.js-upsellDrawer');
  const upsellDrawerBtn = node.querySelector('.js-upsellDrawerBtn');
  const upsellDrawerCloseBtn = node.querySelector('.js-upsellDrawerCloseBtn');
  const upsellList = node.querySelector('.js-upsellList');
  const triggerChat = node.querySelector('.js-triggerChat');
  const campaign = node.querySelector('.js-campaign');
  const freeShippingTarget = Number(document.querySelector('[data-free-shipping-target]')?.dataset.freeShippingTarget);
  const freeShippingMissing = document.querySelector('#free_shipping_left');

  const upsellDrawerActiveClass = 'cart-drawer__upsell--active';

  const config = JSON.parse(node.dataset.config);

  const toggleChatWidget = () => {
    if (!window.GorgiasChat) return false;
    const chat = document.querySelector('#chat-button');

    if (window.GorgiasChat.isOpen()) {
      chat.classList.remove('is-open');
      window.GorgiasChat.close();
    } else {
      chat.classList.add('is-open');
      window.GorgiasChat.open();
      chat.classList.remove('is-open');

      ctx.emit('cart:toggle');
    }

    return true;
  };

  if (triggerChat) {
    triggerChat.addEventListener('click', toggleChatWidget);
  }

  /**
   * Functions
   */
  const addRemoveUpsellDrawer = (open) => {
    upsellDrawer.classList[open ? 'add' : 'remove'](upsellDrawerActiveClass);
  };

   const toggleUpsellDrawer = () => {
    upsellDrawer.classList.toggle(upsellDrawerActiveClass);
  };

  const initDrawers = () => {
    const drawer = Drawer(node);

    ctx.on('cart:toggle', () => drawer.toggle());
    ctx.on('cart:updated', () => {
      drawer.open();
      if (window.matchMedia('(min-width: 1024px)').matches) {
        addRemoveUpsellDrawer(true);
      }
    });

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', () => drawer.close());
    });

    const params = new URLSearchParams(window.location.search);
    if (params.get('cart') !== null) {
      drawer.open();
    }

    upsellDrawerBtn.addEventListener('click', () => toggleUpsellDrawer());
    ctx.on('cart:toggle', () => {
      if (window.matchMedia('(min-width: 1024px)').matches) {
        addRemoveUpsellDrawer(true);
      }
    });
    upsellDrawerCloseBtn.addEventListener('click', () => addRemoveUpsellDrawer(false));
    drawer.on('close', () => addRemoveUpsellDrawer(false));
  };

  const update = ({ itemCount, cartDrawerMarkup }) => {
    const temp = document.createElement('div');
    temp.innerHTML = cartDrawerMarkup;

    const itemCountContent = temp.querySelector('.js-itemCount').textContent;
    itemCountOutput.textContent = itemCountContent;

    const itemListContent = temp.querySelector('.js-itemList').innerHTML;
    itemList.innerHTML = itemListContent;

    const totalPriceContent = temp.querySelector('.js-totalPrice')?.textContent;
    totalPrice.textContent = totalPriceContent;

    // const discountsInfoContent = temp.querySelector('.js-discountsInfo')?.innerHTML;
    // discountsInfo.innerHTML = discountsInfoContent;

    // const discountsLineContent = temp.querySelector('.js-discountsLine')?.innerHTML;
    // discountsLine.innerHTML = discountsLineContent;

    if (campaign) {
      const campaignContent = temp.querySelector('.js-campaign')?.innerHTML;
      campaign.innerHTML = campaignContent;
    }

    if (itemCount > 0) {
      mainContents.hidden = false;
      form.hidden = false;
      empty.hidden = true;
    } else {
      mainContents.hidden = true;
      form.hidden = true;
      empty.hidden = false;

      upsellDrawer.classList.remove(upsellDrawerActiveClass);
    }

    app.mount();
  };

  const updateUpsell = async (cart) => {
    cart.items.forEach(cartItem => {
      const cartItemEl = node?.querySelector('[data-config*="' + cartItem.variantId + '"]');
      const cartItemLength = cartItemEl.querySelector('.js-cartItemLengthOption');
      cartItem.length = cartItemLength ? cartItemLength.innerHTML : 'Standard';
    });

    const fetches = cart.items.map((item) => fetch(`/recommendations/products?product_id=${item.productId}&limit=10&section_id=recommendations`).then((response) => response.text()));

    const fetchesProductsJson = cart.items.map((item) => fetch(`/recommendations/products.json?product_id=${item.productId}`).then((response) => response.json()));
    
    const recommendations = await Promise.all(fetches).then((markups) => markups.map((markup) => {
      const temp = document.createElement('div');
      temp.innerHTML = markup;

      const scriptTag = temp.querySelector('.js-script');
      return JSON.parse(scriptTag.innerHTML);
    }).flat());

    const recommendationsList = await Promise.all(fetchesProductsJson).then((results) => results.map((res) => res ));

    const uniqueRecommendations = [];

    recommendations.forEach((item) => {
      if (!uniqueRecommendations.find((otherItem) => otherItem.handle === item.handle)) {
        uniqueRecommendations.push(item);
      }
    });

    const matchingVariants = [];

    uniqueRecommendations.forEach((item) => {
      if (!item.sizeOption) {
        return;
      }

      const matches = item.variants.filter((variant) => {
        const matchingCartItem = cart.items.find((cartItem) => {
          const matchesFit = cartItem.fit === variant.fit;
          const matchesSize = cartItem.size?.includes(variant.size) || variant.size.includes(cartItem.size); // eslint-disable-line
          const matchesLength = cartItem.length === 'Standard' ? (variant.length === "Standard" || variant.length === null) : cartItem.length === variant.length;

          return matchesFit && matchesSize && matchesLength;
        });

        const alreadyInCart = cart.items.find((cartItem) => (
          cartItem.variantId === variant.id
        ));

        return matchingCartItem && !alreadyInCart && !item.tags.includes('__prelaunch');
      });

      if (matches.length) {
        matchingVariants.push(...matches);
      }
    });

    matchingVariants.sort((a, b) => {
      if (a.available && !b.available) {
        return -1;
      } if (b.available && !a.available) {
        return 1;
      }
      return 0;
    });

    matchingVariants.forEach((variant) => {
      for (const item of recommendationsList) {
        // Search for the product containing the variant
        const product = item.products.find((product) => product.variants.find((v) => v.id === variant.id));

        if (product && product.compare_at_price) {
          variant.compare_at_price = product.compare_at_price;
          break;
        }
      }
    });

    upsellList.innerHTML = matchingVariants.map((item) => UpsellItem(item, { ...config, cart })).join('');

    app.mount();
  };

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    cents = Math.max(0, cents);
  
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  
    function formatWithDelimiters(number, decimals = 2, thousands = '.', decimal = ',') {
      number = (number / 100).toFixed(decimals);
  
      const parts = number.split('.');
      const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      const fraction = parts[1] ? decimal + parts[1] : '';
  
      return whole + fraction;
    }
  
    const formats = {
      'amount': formatWithDelimiters(cents, 2, ',', '.'),
      'amount_no_decimals': formatWithDelimiters(cents, 0, ',', '.'),
      'amount_with_comma_separator': formatWithDelimiters(cents, 2, '.', ','), // 👈 you need this one
      'amount_no_decimals_with_comma_separator': formatWithDelimiters(cents, 0, '.', ','),
      'amount_with_apostrophe_separator': formatWithDelimiters(cents, 2, "'", '.')
    };
  
    return format.replace(placeholderRegex, (match, key) => formats[key] || '');
  }
  
  

  const updateShippingBar = async({cartTotal}) => {
    // Calculate percentage
    const percentage = (cartTotal / freeShippingTarget) * 100;

    // Select elements
    const messageWrapper = document.querySelector(".free-shipping_message-wrapper");
    const progressBar = document.querySelector(".free-shipping_progress-bar");

    const missingAmount = (freeShippingTarget - cartTotal);
    freeShippingMissing.innerHTML = formatMoney(missingAmount, window.theme.moneyFormat);


    // Update class based on percentage
    if (percentage < 100) {
      messageWrapper.classList.add("missing");
      messageWrapper.classList.remove("success");
    } else {
      messageWrapper.classList.add("success");
      messageWrapper.classList.remove("missing");
    }

    // Update progress bar width
    progressBar.style.width = `${Math.min(percentage, 100)}%`; // Ensures it doesn’t exceed 100%
  }

  const initUpsell = async () => {
    const cart = await fetchCart();
    updateUpsell(cart);
  };

  const initGiftProduct = async () => {
    // eslint-disable-next-line no-new
    new GiftProduct(node, ctx);
  };

  const initForm = () => {
    document.body.appendChild(termsModal);
    const modal = Modal(termsModal, false);

    form.addEventListener('submit', (event) => {
      if (!termsInput.checked) {
        event.preventDefault();

        modal.open();
      }
    });

    termsModal.addEventListener('click', (event) => {
      event.stopPropagation();

      if (event.target === termsModal) {
        modal.close();
      }
    });

    termsAcceptBtn.addEventListener('click', () => {
      modal.close();
      termsInput.checked = true;
      form.submit();
    });

    termsDeclineBtn.addEventListener('click', () => {
      modal.close();
    });
  };

  const init = async () => {
    initDrawers();
    initUpsell();
    initGiftProduct();

    ctx.on('cart:updated', (data) => {
      update(data);
      updateUpsell(data);
      updateShippingBar(data);
    });

    initForm();
  };

  /**
   * Init
   */
  init();
});
